import { render } from "./AchievementBox.vue?vue&type=template&id=56a9d98c"
import script from "./AchievementBox.vue?vue&type=script&lang=js"
export * from "./AchievementBox.vue?vue&type=script&lang=js"

import exportComponent from "/root/mentoringplatform-acm/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__